export const environment = {
  production: false,
  apiBaseUrl: 'https://devapi.signing.esignatur.dk',

  // doesn't work for now
  portalBaseUrl: 'https://esignatur-portal-development.azurewebsites.net',
  formsSecureUploadUrl: 'https://dev.formgenerator.esignatur.dk/SecureUpload/External/{0}',
};
